import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function teamsReducer(state = initialState.teams, action) {
  if (action.type === types.LOAD_TEAMS_DATA_SUCCESS) {
    return action.teams;
  }
  return state;
}
